/* Dependencies */
import React, { useEffect, useState } from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Components */
import { Form, Formik } from 'formik';
import { PhotoUploader } from 'lego-dist';
import RenderIf from 'components/RenderIf';

/* Styled Components */
import {
  GeneralInfoWrapper,
  Content,
  Label,
  CharCount,
  PhotoUploaderContainer,
  TextInput,
  InputGroup,
} from '../styles';

/* Services, Hooks, Constants */
import * as Yup from 'yup';

/* Images, Icons */
import ProfileImageFiler from 'images/ProfileImageFiler.png';
import themes from 'themes';

export interface GeneralInfoProps {
  nextStep?: any;
  renderFooter?: any;
  formData?: any;
}

const GeneralInfo: React.FC<GeneralInfoProps> = ({
  renderFooter,
  formData,
}) => {
  const { t } = useTranslation();
  const [formikRef, setFormikRef] = useState<any>({});
  const [initialValuesValid, setInitialValuesValid] = useState(false);

  const { general_info: generalInfo = {} } = formData;
  const initialValues = { ...{ name: '', lastname: '', email: '', avatar: {} }, ...generalInfo || {} };

  // TODO: Review this variable is going to be used, otherwise remove it
  // const [avatar, setAvatar] = useState();
  const [avatarPreview, setAvatarPreview] = useState(ProfileImageFiler);

  /* Validation */
  const memberForm = Yup.object().shape({
    name: Yup
      .string()
      .trim()
      .required(t('validations:FIELD_REQUIRED'))
      .max(70, t('validations:MAX_LENGTH', { amount: 70 })),
    lastname: Yup
      .string()
      .trim()
      .required(t('validations:FIELD_REQUIRED'))
      .max(70, t('validations:MAX_LENGTH', { amount: 70 })),
    email: Yup.string()
      .required(t('validations:FIELD_REQUIRED'))
      .email(t('validations:INVALID_EMAIL')),
  });

  useEffect(() => {
    if (formData?.general_info?.avatar?.name) {
      const fileReader = new FileReader();
      fileReader.onload = (fileLoadedEvent: any) => {
        setAvatarPreview(fileLoadedEvent.target.result);
      };

      fileReader.readAsDataURL(formData?.general_info?.avatar);
    }
  }, [formData]);

  useEffect(() => {
    if (
      formikRef?.validateForm
      && generalInfo?.name
      && generalInfo?.lastname
      && generalInfo?.email
    ) {
      // eslint-disable-next-line no-unused-expressions
      formikRef?.validateForm(generalInfo)
        .then((res: any) => {
          setInitialValuesValid(Object.keys(res).length === 0);
        });
    }
  }, [formikRef, generalInfo]);

  return (
    <GeneralInfoWrapper>
      <Formik
        ref={(ref) => setFormikRef(ref)}
        initialValues={initialValues}
        validationSchema={memberForm}
        onSubmit={(res: any) => console.info('GeneralInformationStep Formik onSubmit', res)}
        // isInitialValid
        validateOnBlur
        validateOnChange
        render={({ setFieldValue, errors, touched, values, isValid }) => (
          <Form>
            <Content>
              <p>{t('settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.GENERAL_INFO.TITLE')}</p>
              <PhotoUploaderContainer>
                {t('settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.GENERAL_INFO.UPLOAD_IMAGE')}
                <PhotoUploader
                  src={avatarPreview}
                  negativeButtonText={t('CANCEL')}
                  previewModalProps={{headerColor: themes.colors.newKinedu }}
                  positiveButtonProps={{
                    children: t('SAVE'),
                    onClickButton: console.info
                  }}
                  onCroppedFile={({ uploadFileToS3, croppedFile }: any) => {
                    // setAvatar(croppedFile);
                    setFieldValue('avatar', croppedFile);
                    // uploadOrgAvatarToS3 = () => uploadFileToS3(croppedFile);
                  }}
                  onUploadedFile={(file: any) => {
                    // setAvatar(file.path);
                  }}
                  s3UploaderProps={
                    {
                      // processFilename: (filename: string) => {
                      //   // TODO: Add possible request to preocess filename at the kinedu backend:
                      //   // commonService.processFilesToS3(newName, '');
                      //   const fileSubstrings = filename.split('.');
                      //   return `${Date.now()}_${classroom?.id}_file.${
                      //     fileSubstrings[fileSubstrings.length - 1]
                      //   }`;
                      // },
                      // s3path: `/${orgId}/avatars/`,
                      // apiURL: FILES_API_URL,
                      // bucket: S3_BUCKET_FILES,
                    }
                  }
                  multipart
                />
              </PhotoUploaderContainer>
              <InputGroup>
                <Label>
                  <span>{t('NAME')}</span>
                  <CharCount>
                    {`${values?.name?.length} / 70`}
                  </CharCount>
                </Label>
                <TextInput
                  onChange={(event: any) => {
                    setFieldValue('name', event);
                  }}
                  placeholder={t('common:ADD_NAME')}
                  value={generalInfo.name}
                  maxLength={70}
                  errorMessage={errors.name}
                />
              </InputGroup>
              <InputGroup>
                <Label>
                  <span>{t('LAST_NAME')}</span>
                  <CharCount>
                    {`${values?.lastname?.length} / 70`}
                  </CharCount>
                </Label>
                <TextInput
                  onChange={(event: any) => {
                    setFieldValue('lastname', event);
                  }}
                  placeholder={t('common:ADD_LAST_NAME')}
                  value={generalInfo.lastname}
                  maxLength={70}
                  errorMessage={errors.lastname}
                />
              </InputGroup>
              <InputGroup>
                <Label>
                  <span>{t('EMAIL')}</span>
                </Label>
                <TextInput
                  onChange={(event: any) => {
                    setFieldValue('email', event);
                  }}
                  value={generalInfo.email}
                  placeholder={t('common:ADD_EMAIL')}
                  errorMessage={errors.email}
                />
              </InputGroup>
            </Content>
            <RenderIf condition={renderFooter}>
              {renderFooter(isValid || initialValuesValid, {
                general_info: values,
              })}
            </RenderIf>
          </Form>
        )}
      />
    </GeneralInfoWrapper>
  );
};

export default GeneralInfo;
